@use '@/styles/tokens' as *;

.bodyReset {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer :global(.ant-drawer-content) {
  background: var(--surface-card);
  box-shadow: var(--shadow-overlay);
}

@media (prefers-reduced-motion: reduce) {
  .drawer :global(.ant-drawer-content-wrapper),
  .drawer :global(.ant-drawer-mask) {
    transition-duration: 0.001ms !important;
  }
}
